import type { EChartsOption } from 'echarts';
import { useMemo } from 'react';

import { PALETTE } from 'entities/analytics/lib';
import { useGeography } from 'entities/analytics/model';
import { AnalyticsCard } from 'entities/analytics/ui/analytics-card';
import { EChart } from 'entities/analytics/ui/echart';

const TOP_N = 5;

export const PetsSpeciesCard = () => {
  const { data, isLoading, isFetching } = useGeography();
  const rows = useMemo(() => data?.data.series ?? [], [data]);

  const top = useMemo(
    () =>
      [...rows]
        .filter((r) => r.code)
        .sort((a, b) => b.pets - a.pets)
        .slice(0, TOP_N),
    [rows],
  );

  const option = useMemo<EChartsOption>(
    () => ({
      grid: { left: 8, right: 28, top: 8, bottom: 30, containLabel: true },
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      legend: { bottom: 0, textStyle: { color: PALETTE.axis, fontSize: 11 }, itemHeight: 9 },
      xAxis: {
        type: 'value',
        axisLine: { lineStyle: { color: '#dfe5e3' } },
        splitLine: { lineStyle: { color: PALETTE.grid } },
        axisLabel: { color: PALETTE.axis },
      },
      yAxis: {
        type: 'category',
        inverse: true,
        data: top.map((r) => r.name),
        axisTick: { show: false },
        axisLine: { lineStyle: { color: '#dfe5e3' } },
        axisLabel: { color: '#40514d', fontSize: 12 },
      },
      series: [
        {
          name: 'Dogs',
          type: 'bar',
          stack: 'pets',
          data: top.map((r) => r.dogs),
          itemStyle: { color: PALETTE.primary },
        },
        {
          name: 'Cats',
          type: 'bar',
          stack: 'pets',
          data: top.map((r) => r.cats),
          itemStyle: { color: PALETTE.amber, borderRadius: [0, 4, 4, 0] },
        },
      ],
    }),
    [top],
  );

  return (
    <AnalyticsCard
      title="Pets: dogs vs cats"
      subtitle="Top countries · split by species"
      isLoading={isLoading}
      isFetching={isFetching}
      isEmpty={!isLoading && rows.length === 0}
      emptyMessage="No data"
      chartHeight={300}
      chart={<EChart option={option} height={300} />}
    />
  );
};
